import { FavoritesRequest, MemberDetailedInfo, User } from "@/types";

import { axios } from "../axios.instance";

export type GetAdmiredUsersRequest = FavoritesRequest & {
  perPage?: number;
  cursor?: string;
};

export type GetAdmiredUsersResponse = {
  data: Array<Pick<User, "id" | "role"> & MemberDetailedInfo>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getAdmiredUsers = async (params: GetAdmiredUsersRequest): Promise<GetAdmiredUsersResponse> => {
  const { data } = await axios.get(`/admires/users/admire-me`, {
    params,
  });

  return data;
};
